/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FileTypeEnum } from './fileTypeEnum';

/**
 * Serializer for announcement attachments.
 */
export interface AnnouncementAttachment { 
    readonly id: string;
    file: string;
    fileName: string;
    fileSize: number;
    fileType?: FileTypeEnum;
    thumbnail?: string;
    /**
     * Converted MP4 version of the video
     */
    convertedMp4?: string;
    /**
     * Converted WebM version of the video
     */
    convertedWebm?: string;
    readonly created: Date;
}